import React, { useState } from "react";
import Lightbox from "react-awesome-lightbox";
import "react-awesome-lightbox/build/style.css";

const GalleryI = () => {
  const images = [
    //1//
    {
      src: "/img/portfolio/industrielle/img17_compression.jpg",
      alt: "photo 1",
    },

    {
      src: "/img/portfolio/industrielle/img6_compression.jpg",
      alt: "photo 2",
    },

    {
      src: "/img/portfolio/industrielle/img4_compression.jpg",
      alt: "photo 3",
    },
    //2//
    {
      src: "/img/portfolio/industrielle/img10_compression.jpg",
      alt: "photo 4",
    },
    {
      src: "/img/portfolio/industrielle/img15_compression.jpg",
      alt: "photo 5",
    },

    {
      src: "/img/portfolio/industrielle/img7_compression.jpg",
      alt: "photo 6",
    },
    //3//

    {
      src: "/img/portfolio/industrielle/img1.webp",
      alt: "photo 7",
    },
    {
      src: "/img/portfolio/industrielle/img2.webp",
      alt: "photo 8",
    },
    {
      src: "/img/portfolio/RECADRAGE/o0cyiizrz7q4rhbqbd2g.webp",
      alt: "photo 9",
    },

    //4//
    {
      src: "/img/portfolio/industrielle/img11_compression.jpg",
      alt: "photo 10",
    },
    {
      src: "/img/portfolio/industrielle/img16_compression.jpg",
      alt: "photo 11",
    },
    {
      src: "/img/portfolio/industrielle/img14_compression.jpg",
      alt: "photo 12",
    },

    //5//
    {
      src: "/img/portfolio/industrielle/img13_compression.jpg",
      alt: "photo 13",
    },
    {
      src: "/img/portfolio/industrielle/img5_compression.jpg",
      alt: "photo 14",
    },
    {
      src: "/img/portfolio/industrielle//img18_compression.jpg",
      alt: "photo 15",
    },
  ];

  const [isOpen, setIsOpen] = useState(false);
  const [photoIndex, setPhotoIndex] = useState(0);

  return (
    <>
      {/* Section Header */}
      <section
        className="banner-header banner-img banner-img-top section-padding valign bg-img bg-fixed banner-overlay"
        data-overlay-darkgray="1"
        style={{
          backgroundImage:
            "url('/img/portfolio/industrielle/img13_compression.jpg')",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-md-5">
              <h1>Industriel</h1>
              <hr className="border-1" />
              <p>
                Mettez en lumière votre expertise avec des photographies
                industrielles qui valorisent vos gestes, vos outils et votre
                savoir-faire
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Section Portfolio */}
      <section className="section-padding bg-blck">
        <div className="container">
          <div className="row">
            {images.map((image, index) => (
              <div key={index} className="col-md-4 gallery-item">
                <div
                  className="img-zoom"
                  onClick={() => {
                    setPhotoIndex(index);
                    setIsOpen(true);
                  }}
                >
                  <div className="gallery-box">
                    <div className="gallery-img">
                      <img
                        src={image.src}
                        className="img-fluid mx-auto d-block"
                        alt={image.alt}
                      />
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Lightbox */}
        {isOpen && (
          <Lightbox
            images={images.map((img) => ({ url: img.src, title: img.title }))}
            startIndex={photoIndex}
            onClose={() => setIsOpen(false)}
          />
        )}
      </section>
    </>
  );
};

export default GalleryI;
